import { render } from "./TranferWorkView.vue?vue&type=template&id=0a193bbf&scoped=true"
import script from "./TranferWorkView.vue?vue&type=script&lang=js"
export * from "./TranferWorkView.vue?vue&type=script&lang=js"

import "./TranferWorkView.vue?vue&type=style&index=0&id=0a193bbf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a193bbf"]])

export default __exports__